@if (tableConstructionData) {
  <app-generic-table
    [tableData]="tableConstructionData()"
    [searchTerm]="searchTerm"
    [actionHandler]="actionHandler"

    wctLoadingIndicator
    [apiSignal]="undefined"
    [apiCallAdditionalLoading]="loading"

    [attr.faded]="loading() ? true : null">

    <ng-content empty select="[empty]"></ng-content>
    <ng-content no-results select="[no-results]"></ng-content>

  </app-generic-table>
} @else {
  <div class="wct-relative placeholder">
    <sd-4-5-1-spinner class="wct-absolute-center"></sd-4-5-1-spinner>
  </div>
}
@if (error) {
  <span>{{ errorText }}</span>
}
